import { motion } from "framer-motion";
import { LucideIcon } from "lucide-react";

interface ServiceCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}
export const ServiceCard = ({
    icon: Icon,
    title,
    description,
  }: ServiceCardProps) => {
    return (
      <motion.div
        whileHover={{
          y: -5,
        }}
        className="p-6 rounded-xl bg-gray-800/40 backdrop-blur-lg border border-gray-700/50 group hover:bg-gray-800/60 transition-all duration-300 h-[280px] flex flex-col justify-between"
      >
        <motion.div
          initial={{
            scale: 1,
          }}
          whileHover={{
            scale: 1.1,
          }}
          className="w-16 h-16 rounded-full bg-blue-600/10 flex items-center justify-center mx-auto group-hover:bg-blue-600/20 transition-colors"
        >
          <Icon className="w-8 h-8 text-blue-400" />
        </motion.div>
        <h3 className="text-xl font-semibold text-center bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
          {title}
        </h3>
        <p className="text-gray-300 text-center text-sm leading-relaxed">
          {description}
        </p>
      </motion.div>
    );
  };
  
